__turbopack_context__.v({
  "className": "playfair_display_44b9d863-module__9E9cWW__className",
});
